import { FC, useMemo } from "react";
import { Button } from "@quark/design";
import styles from "./index.module.scss";
import { ExamDetail } from "../../../../types/exam";

interface ExamPracticeFooterProps {
  exam: ExamDetail;
  currentIndex: number;
  onPrev: () => void;
  onNext: () => void;
}

const ExamPracticeFooter: FC<ExamPracticeFooterProps> = ({
  exam,
  currentIndex,
  onPrev,
  onNext,
}) => {
  const hasPrev = useMemo(() => {
    return currentIndex !== 0;
  }, [currentIndex]);

  const hasNext = useMemo(() => {
    return currentIndex !== exam.quiz_num - 1;
  }, [currentIndex, exam]);

  return (
    <div className={styles.footer}>
      <div className={styles.footerContent}>
        <Button disabled={!hasPrev} onClick={onPrev}>
          上一题
        </Button>
        <Button variant="filled" disabled={!hasNext} onClick={onNext}>
          下一题
        </Button>
      </div>
    </div>
  );
};

export default ExamPracticeFooter;
